// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Gcg9","header":"ReportDetails_header__1Bj6x","title":"ReportDetails_title__2ngBf","left":"ReportDetails_left__2t9ba"};